import * as preact from "preact"
import { JSX } from "preact";
import { $$ } from "./Common";

export class RequestManager extends preact.Component
{
    private _pnlShield: HTMLElement;
    private _isoFormat: RegExp = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(\.[0-9]+)?Z?$/;

    constructor(props)
    {
        super(props);
    }

    public execute(url: string, content?: any, success?: Function, failure?: Function, skipShield?: boolean): AbortController
    {
        if (!skipShield)
        {
            $$.show(this._pnlShield);
        }

        let ok = false;
        if (!failure)
        {
            failure = $$.serviceError();
        }

        let abortController = new AbortController();

        fetch(url,
            {
                signal: abortController.signal,
                method: "POST",
                headers:
                {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify(content, (key: string, value: any) =>
                {
                    if (value == null)
                    {
                        return undefined;
                    }
                    if (value instanceof Date)
                    {
                        return value.toISOString();
                    }
                    return value;
                })
            })
            .then(async response =>
            {
                ok = response.ok;
                try
                {
                    return response.text();
                }
                catch
                {
                    return null;
                }
            })
            .then((text) =>
            {
                let data;
                try
                {
                    data = JSON.parse(text, (key: string, value: any) =>
                    {
                        if (value && typeof value === "string")
                        {
                            if (this._isoFormat.test(value))
                            {
                                return new Date(value);
                            }
                        }
                        return value;
                    });
                }
                catch
                {
                    data = text;
                }

                $$.hide(this._pnlShield);
                if (ok)
                {
                    if (success)
                    {
                        success(data || null);
                    }
                }
                else if (failure)
                {
                    failure(data || null);
                }
            })
            .catch((error) =>
            {
                $$.hide(this._pnlShield);
                failure(error);
            })

        return abortController;
    }


    public skipShield(): void
    {

    }

    public render(): JSX.Element
    {
        return (<div ref={(ref) => this._pnlShield = ref} className="shield" style={{ display: "none" }}><div className="spinner"></div></div>);
    }

}

export var $$requestManager: RequestManager;
let element = preact.createElement(RequestManager, { ref: (ref) => { $$requestManager = ref } });
$$.appendChild(document.body, element);